/**
 * Green Flag — EventCard slot recipe
 *
 * Horizontal card: 116×116 image tile on the left, text block + sparks chip on
 * the right. Used in the "EXPLORE UPCOMING EVENTS" list on Home.
 */

import { defineSlotRecipe } from "@chakra-ui/react";

export const eventCardRecipe = defineSlotRecipe({
  className: "gf-event-card",
  slots: ["root", "image", "body", "date", "title", "meta", "sparks"],

  base: {
    root: {
      display: "flex",
      gap: "3",
      p: "1",
      borderRadius: "sm",
      bg: "bg.canvas",
      boxShadow: "card",
      cursor: "pointer",
      transitionProperty: "transform, filter",
      transitionDuration: "fast",
      _hover: { filter: "brightness(1.02)" },
      _active: { transform: "translateY(0.5px)" },
    },
    image: {
      w: "116px",
      h: "116px",
      borderRadius: "xs",
      bg: "border.default",
      backgroundSize: "cover",
      backgroundPosition: "center",
      flex: "0 0 116px",
    },
    body: {
      flex: 1,
      p: "1",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      gap: "0.5",
    },
    date: {
      textStyle: "eyebrow",
      color: "fg.default",
    },
    title: {
      fontFamily: "body",
      fontWeight: "medium",
      fontSize: "lg",
      lineHeight: "tight",
      color: "fg.default",
    },
    meta: {
      fontFamily: "body",
      fontSize: "lg",
      color: "fg.default",
    },
    sparks: {
      mt: "1",
    },
  },
});
